var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSoul(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.37 26.495c1.002 0 1.477-.792 1.583-4.17.075-2.41.043-7.02.019-10.558-.01-1.424-.019-2.676-.019-3.54 0-3.009-2.323-5.226-5.227-5.226H6.406c-.704-.017-2.323.35-3.38 1.743C1.98 6.126 1.997 7.11 2.022 8.566c.007.378.014.788.003 1.245-.041 1.759-.017 8.59-.005 11.927l.005 1.749c0 .112-.001.23-.004.353-.02 1.147-.045 2.655 1.482 2.655.803 0 1.164-.346 1.544-.709.42-.4.86-.822 1.94-.822 1.106 0 1.816.913 2.473 1.76.566.729 1.094 1.408 1.803 1.408.695 0 1.28-.653 1.921-1.365.77-.858 1.62-1.803 2.83-1.803 1.212 0 1.982.945 2.68 1.803.582.712 1.114 1.365 1.808 1.365.635 0 1.042-.544 1.52-1.18.676-.9 1.491-1.988 3.285-1.988.81 0 1.351.46 1.84.876.402.343.77.655 1.222.655zM10.63 14.933a2.904 2.904 0 1 0 0-5.808 2.904 2.904 0 0 0 0 5.808zm13.463-2.904a2.904 2.904 0 1 1-5.808-.001 2.904 2.904 0 0 1 5.808-.001zm-11.721-.001a1.795 1.795 0 1 1-3.59-.001 1.795 1.795 0 0 1 3.59-.001zm10.665-.001a1.795 1.795 0 1 1-3.59-.001 1.795 1.795 0 0 1 3.59-.001z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSoul);
export default __webpack_public_path__ + "static/media/SOUL.d0278da6da1c49fd956047ae89b57ce8.svg";
export { ForwardRef as ReactComponent };